// this file is generated, do not edit directly
// source is postgres/init-local/03_static.sql

export const currencies = {
  SOL: { code: "SOL", scale: 4, is_tradeable: true, usd_conversion_rate: null },
  MNDE: { code: "MNDE", scale: 2, is_tradeable: true, usd_conversion_rate: null },
  SWTCH: { code: "SWTCH", scale: 2, is_tradeable: true, usd_conversion_rate: null },
  MPLX: { code: "MPLX", scale: 2, is_tradeable: true, usd_conversion_rate: null },
  DRVS: { code: "DRVS", scale: 2, is_tradeable: false, usd_conversion_rate: "0.3" },
  USDC: { code: "USDC", scale: 2, is_tradeable: true, usd_conversion_rate: "1" },
  ZRC: { code: "ZRC", scale: 2, is_tradeable: true, usd_conversion_rate: null },
} as const;

export const currencyList = [
  "SOL",
  "MNDE",
  "SWTCH",
  "MPLX",
  "DRVS",
  "USDC",
  "ZRC",
] as const;
